// trạng thái báo cáo mà cấp dưới xem khi báo cáo được xử lý tại lekima
export default {
  Sent: 0, // đã nộp
  Submitted: 1, // đã hoàn thành xét duyệt
  NeedAdjust: 2, // cần sửa lại
  Resent: 3, // đã nộp lại
  NoSent: 4, // TODO: chưa nộp
};
